import React, { useRef, useState } from "react";
import "./Contact.css";
import {
  Button,
  Col,
  Container,
  Form,
  Row,
  Alert,
  Spinner,
} from "react-bootstrap";
import emailjs from "@emailjs/browser";
import {
  Facebook,
  Github,
  Linkedin,
  Envelope,
  Instagram,
  Telephone,
} from "react-bootstrap-icons";

const Contact = () => {
  const form = useRef();
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);

    emailjs
      .sendForm(
        "service_jqkqmlw",
        "template_0g5hiaf",
        form.current,
        "BGC06wD52wpCoiGBv"
      )
      .then(
        (result) => {
          console.log("SUCCESS!", result.text);
          setSuccessMessage("Your message has been sent successfully!");
          form.current.reset();
          setLoading(false);
        },
        (error) => {
          console.log("FAILED...", error.text);
          setLoading(false);
        }
      );
  };

  return (
    <Container fluid="md" className="contact-section" id="contact">
      <Row>
        <Col>
          <Form ref={form} onSubmit={sendEmail} className="form-section">
            <Form.Group controlId="formName">
              <Form.Control
                required
                type="text"
                placeholder="Your name*"
                name="user_name"
              />
            </Form.Group>
            <Form.Group controlId="formEmail">
              <Form.Control
                type="email"
                placeholder="Email"
                name="user_email"
              />
            </Form.Group>
            <Form.Group controlId="formPhone">
              <Form.Control
                type="tel"
                placeholder="Phone Number"
                name="user_number"
              />
            </Form.Group>
            <Form.Group controlId="formMessage">
              <Form.Control
                required
                as="textarea"
                placeholder="How can I help?*"
                name="message"
              />
            </Form.Group>
            <div className="contact-social">
              <Button type="submit" disabled={loading}>
                {loading ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  "Get In Touch"
                )}
              </Button>
              <div className="social-links">
                <a
                  href="https://github.com/sandunde"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Github className="black-social" />
                </a>
              </div>
              <div className="social-links-white">
                <a
                  href="https://www.linkedin.com/in/sandun-de-silva-6253861b8/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Linkedin className="white-social" />
                </a>
              </div>
              <div className="social-links-white">
                <a
                  href="https://www.instagram.com/sha.ggy_sus/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Instagram className="white-social" />
                </a>
              </div>
              <div className="social-links-white">
                <a
                  href="https://www.facebook.com/ab.dimaria.39"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Facebook className="white-social" />
                </a>
              </div>
            </div>
          </Form>
          {successMessage && (
            <Alert variant="success" className="mt-3">
              {successMessage}
            </Alert>
          )}
        </Col>
        <Col className="contact-content">
          <h3>
            <span className="text-bold-contact"> Let's</span>
            <span className="text-border-contact"> talk</span>
            <span className="text-bold-contact"> for</span> <br />
            <span className="text-bold-contact">Something Special</span>{" "}
          </h3>
          <p>
            I seek to push the limits of creativity to create high-engaging,
            user- <br />
            friendly, and memorable interactive experiences.
          </p>
          <div className="contact-email">
            <a className="contact-email" href="mailto:sandundimaria7@gmail.com" style={{ textDecoration: "none", color: "#000" }}>
              <Envelope size={"35px"} className="responsive-icon" />
              <h5>: sandundimaria7@gmail.com</h5>
            </a>
          </div>
          <div className="contact-email">
            <a className="contact-email" href="tel:+94765537625" style={{ textDecoration: "none", color: "#000" }}>
              <Telephone size={"35px"} className="responsive-icon" />
              <h5>: +94 765 553 7625</h5>
            </a>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Contact;
